import TextGrouping from './TextGrouping';

export default TextGrouping;
